import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import httpClient from "../https/client.js";

export const useApi = () => {
  const fetchData = async (endpoint, params = {}) => {
    const response = await httpClient.get(endpoint, { params });
    return response.data;
  };

  const fetchDataWithHeaders = async (endpoint, params = {}) => {
    const response = await httpClient.get(endpoint, { params });
    return {data : response.data, headers : response.headers};
  };

  const postData = async (endpoint, data) => {
    const response = await httpClient.post(endpoint, data);
    return response.data;
  };

  const putData = async (endpoint, data) => {
    const response = await httpClient.put(endpoint, data);
    return response.data;
  };

  const deleteData = async (endpoint, id) => {
    const response = await httpClient.delete(`${endpoint}/${id}`);
    return response.data;
  };

  return {
    useGetQuery: (queryKey, endpoint, params) =>
      useQuery({
        queryKey,
        queryFn: () => {
          if (endpoint) {
            return fetchData(endpoint, params);
          }
        },
      }),
      useGetQueryWithHeaders: (queryKey, endpoint, params) =>
        useQuery({
          queryKey,
          queryFn: () => {
            if (endpoint) {
              return fetchDataWithHeaders(endpoint, params);
            }
          },
        }),
    usePostMutation: (endpoint, options) =>
      useMutation({
        mutationFn: (data) => postData(endpoint, data),
        ...options,
      }),
    usePostMutationWithId: (endpoint, options) =>
      useMutation({
        mutationFn: (data) => {
          const tempEndpoint = data?.endpoint || ""
          if(data?.endpoint) {
            delete data.endpoint
          }
          return postData(endpoint + tempEndpoint || "", data)
        },
        ...options,
      }),
    usePutMutation: (endpoint, options) =>
      useMutation({
        mutationFn: (data) => putData(endpoint, data),
        ...options,
      }),
    useDeleteMutation: (endpoint, options) =>
      useMutation({
        mutationFn: ({ id }) => deleteData(endpoint, id),
        ...options,
      }),
  };
};
